
































































import {
  defineComponent, computed, ref, watch, PropType,
} from '@vue/composition-api';
import { Popup, Toast } from '@hb/coffee';
import { RightArrowOutline12, CloseOutline } from '@hb/coffee-icons';
import { ubtSetupModuleExpose } from '@/shared/utils/ubt/ubt-setup';
import { LoanUsageOption } from '@/api/apply-product/types';
import { TP_QUICK_WITHDRAW_CARD_OTHER_INFO } from '../../tianqi';
import LoanPurposePopup from './loan-purpose-popup.vue';

// static component
// [功能说明]: 其他信息弹窗组件
interface Props {
  modelValue?: boolean;
  institutionName?: string;
  loanPurposeOptions?: LoanUsageOption[];
  selectedLoanPurpose?: LoanUsageOption;
  containerHeight?: number;
  capitalCode?: string;
  productId?: string;
  rightLightUncreditedProduct?: {
    productId: string;
    productName: string;
  };
}

export default defineComponent({
  name: 'OtherInfoPopup',
  components: {
    Popup,
    RightArrowOutline12,
    LoanPurposePopup,
    CloseOutline,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    institutionName: {
      type: String,
      default: '马上消金',
    },
    loanPurposeOptions: {
      type: Array as PropType<LoanUsageOption[]>,
      default: () => [],
    },
    selectedLoanPurpose: {
      type: Object as PropType<LoanUsageOption>,
      default: () => ({
        name: '购物消费', code: 'shopping', available: true, sort: 0,
      }),
    },
    containerHeight: {
      type: Number,
      default: 0,
    },
    capitalCode: {
      type: String,
      default: '',
    },
    productId: {
      type: String,
      default: '',
    },
    rightLightUncreditedProduct: {
      type: Object as PropType<{
        productId: string;
        productName: string;
      }>,
    },
  },
  emits: ['update:modelValue', 'close', 'update:selectedLoanPurpose'],
  setup(props: Props, { emit }) {
    // 弹窗显示状态
    const showPopup = computed({
      get: () => props.modelValue,
      set: (value) => emit('update:modelValue', value),
    });

    const hasActiveInstitution = computed(() => (
      props.rightLightUncreditedProduct
      && Object.keys(props.rightLightUncreditedProduct).length > 0
    ));

    // 借款用途弹窗显示状态
    const showPurposePopup = ref(false);

    // 选中的借款用途 - 使用响应式数据，支持本地更新
    const selectedPurpose = ref({
      value: props.selectedLoanPurpose?.code || 'shopping',
      label: props.selectedLoanPurpose?.name || '购物消费',
    });

    // 监听 props 变化，同步到本地状态
    watch(() => props.selectedLoanPurpose, (newPurpose) => {
      if (newPurpose) {
        selectedPurpose.value = {
          value: newPurpose.code,
          label: newPurpose.name,
        };
      }
    }, { immediate: true });


    // 当前选中用途的标签
    const selectedPurposeLabel = computed(() => selectedPurpose.value.label);


    // 监听弹窗显示状态，触发曝光埋点
    watch(
      () => props.modelValue,
      (isVisible) => {
        if (isVisible) {
          ubtSetupModuleExpose(TP_QUICK_WITHDRAW_CARD_OTHER_INFO, {
            loanPurpose: selectedPurposeLabel.value,
            capitalCode: props.capitalCode,
            productId: props.productId,
          });
        }
      },
    );

    // 处理关闭弹窗
    const handleClose = () => {
      emit('update:modelValue', false);
      emit('close');
    };

    // 处理借款用途点击
    const handlePurposeClick = () => {
      showPurposePopup.value = true;
    };

    // 处理借款用途选择
    const handlePurposeSelect = (purpose: any) => {
      showPurposePopup.value = false;

      // 立即更新本地显示值
      selectedPurpose.value = {
        value: purpose.value,
        label: purpose.label,
      };

      // 通知父组件更新选中的借款用途
      const selectedOption = props.loanPurposeOptions?.find(
        (option) => option.code === purpose.value
      );

      if (selectedOption) {
        emit('update:selectedLoanPurpose', selectedOption);
      }
    };

    // 处理借款用途取消
    const handlePurposeCancel = () => {
      showPurposePopup.value = false;
    };

    const handleRightLightUncreditedProductClick = () => {
      Toast('您选择的机构暂时无法为您提供服务，您可以选择其他机构或稍后再试');
    };

    return {
      showPopup,
      showPurposePopup,
      selectedPurpose,
      selectedPurposeLabel,
      hasActiveInstitution,
      handleClose,
      handlePurposeClick,
      handlePurposeSelect,
      handlePurposeCancel,
      handleRightLightUncreditedProductClick,
      containerHeight: props.containerHeight,
    };
  },
});
